import Config from "./config"

import { isBrowser } from "./"

const TRACKING_COOKIE_NAME = "bsdex_tracking"
const CAMPAIGN_COOKIE_NAME = "bsdex_campaign"
const COOKIE_DOMAIN = Config().trackingCookieDomain

// fallback function for Edge
const fromEntriesFallback = (arrayOfTuples) =>
  arrayOfTuples.reduce((obj, [name, value]) => {
    const next = obj
    next[name] = value
    return next
  }, {})

const objectFromEntries = Object.fromEntries || fromEntriesFallback

const parseTrackingParams = (
  search = isBrowser() && window.location.search
) => {
  try {
    const trackingParamsArray = Array.from(
      new URLSearchParams(search).entries()
    ).filter(
      ([paramName]) =>
        paramName.startsWith("utm_") ||
        paramName === "gclid" ||
        paramName === "mclid"
    )

    if (trackingParamsArray.length === 0) {
      return
    }

    return objectFromEntries(trackingParamsArray)
  } catch (error) {}
}

export const storeTrackingParams = (params) => {
  document.cookie = `${TRACKING_COOKIE_NAME}=${encodeURIComponent(
    JSON.stringify(params)
  )};${COOKIE_DOMAIN ? `domain=${COOKIE_DOMAIN}` : ``};path=/`
}

export const storeCampaignCookie = (campaignIdentifier) => {
  if (!campaignIdentifier) {
    return
  }

  document.cookie = `${CAMPAIGN_COOKIE_NAME}=${encodeURIComponent(
    campaignIdentifier
  )};${COOKIE_DOMAIN ? `domain=${COOKIE_DOMAIN}` : ``};path=/`
}

export const getCookieValue = (cookieName) => {
  const cookie = document.cookie
    .split(";")
    .map((c) => c.trim())
    .filter((c) => c.startsWith(`${cookieName}=`))[0]

  if (!cookie) {
    return
  }

  return decodeURIComponent(cookie.split("=")[1])
}

export const getStoredCampaignInfo = () => {
  return getCookieValue(CAMPAIGN_COOKIE_NAME)
}

export const getStoredTrackingParams = () => {
  return getCookieValue(TRACKING_COOKIE_NAME)
}

export const getStoredTrackingParamsObject = () => {
  try {
    const trackingParams = JSON.parse(getStoredTrackingParams() || {})
    const campaignParams = { [CAMPAIGN_COOKIE_NAME]: getStoredCampaignInfo() }
    return Object.assign({}, trackingParams, campaignParams)
  } catch (_error) {}
}

export const collectAndStoreTrackingParams = (
  search = isBrowser() && window.location.search
) => {
  const params = parseTrackingParams(search)
  if (!params) {
    return
  }

  storeTrackingParams(params)
}

collectAndStoreTrackingParams()
